import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
export const getStartDateTime = (date) => {
  return dayjs(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
};
export const getEndDateTime = (date) => {
  return dayjs(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
};
export const dateTimeToUtc = (dateTime) => {
  return dayjs.utc(new Date(dateTime)).format("YYYY-MM-DD HH:mm:ss");
};
export const utcDateTimeToLocal = (dateTime) => {
  return dayjs.utc(dateTime).local().format("YYYY-MM-DD HH:mm:ss");
};
export const utcDateTimeToLocalPA = (dateTime) => {
  return dayjs.utc(dateTime).local().format("YYYY-MM-DD h:mm A");
};
export const utcDateToLocalPA = (dateTime) => {
  return dayjs.utc(dateTime).local().format("D MMMM, YYYY");
};
export const utcDateToLocalSimple = (dateTime) => {
  return dayjs.utc(dateTime).local().format("YYYY-MM-DD");
};
export const utcTimeToLocalPA = (dateTime) => {
  return dayjs.utc(dateTime).local().format("h:mm A");
};
export const onlyDateFun = (dateTime) => {
  return dayjs(dateTime).format("YYYY-MM-DD");
};
export const onlyDateTimeFun = (dateTime) => {
  return dayjs(dateTime).format("YYYY-MM-DD HH:mm");
};
export const FormatDateTimeFun = (dateTime) => {
  return dayjs(dateTime).format("D MMMM, YYYY h:mm A");
};

export const onlyTimeFun = (date) => {
  if (!date) return "";
  return dayjs(date).format("hh:mm A");
};

export const utcDateTimeToLocalPAOnly = (dateTime) => {
  return dayjs.utc(dateTime).local();
};
